/* One square per piece, three angles inside it.
   Pointer: cycles through the angles while hovered.
   Touch: tap advances one angle (no hover to rely on).
   Exposed as a function so it can run after the catalog renders. */
(() => {
  const STEP_MS = 1100;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGalleries(root) {
    (root || document).querySelectorAll('.piece:not([data-gallery-on])').forEach(piece => {
      const shots = Array.from(piece.querySelectorAll('.shot'));
      // ticks sit inside the square on the products page but in the caption
      // beside it on the home grid, so look from the wrapper down
      const scope = piece.closest('figure, article') || piece;
      const ticks = Array.from(scope.querySelectorAll('.tick'));
      if (shots.length < 2) return;
      piece.setAttribute('data-gallery-on', '');

      let index = 0;
      let timer = null;

      const show = n => {
        index = (n + shots.length) % shots.length;
        shots.forEach((s, i) => s.classList.toggle('is-on', i === index));
        ticks.forEach((t, i) => t.classList.toggle('is-on', i === index));
      };

      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => {
        if (reduced || timer) return;
        timer = setInterval(() => show(index + 1), STEP_MS);
      };

      piece.addEventListener('pointerenter', e => {
        if (e.pointerType === 'mouse') { show(index + 1); start(); }
      });
      piece.addEventListener('pointerleave', e => {
        if (e.pointerType === 'mouse') { stop(); show(0); }
      });

      // a piece that links somewhere (home grid) navigates on click/tap;
      // a plain piece (products page) steps through its angles by hand
      if (!('link' in piece.dataset)) {
        piece.addEventListener('click', e => {
          if (e.pointerType === 'mouse' && !reduced) return;
          e.preventDefault();
          stop();
          show(index + 1);
        });
        piece.addEventListener('keydown', e => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          stop();
          show(index + 1);
        });
      }

      show(0);
    });
  }

  window.initGalleries = initGalleries;
  document.addEventListener('DOMContentLoaded', () => initGalleries(document));
})();
